import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { logger } from '../../utils/logger';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * PublicRoute component that redirects authenticated users away from auth pages
 * Used for routes like sign-in, sign-up that should only be accessible when logged out
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show loading state while authentication state is being determined
  if (loading) {
    return <div>Loading...</div>;
  }

  // If user is already logged in, redirect to profile page
  if (currentUser) {
    logger.info('🔒 Redirecting authenticated user away from auth page');
    
    // Use the 'from' path if it exists, otherwise go to profile
    const from = location.state?.from?.pathname || '/my-profile';
    return <Navigate to={from} replace />;
  }

  // User is not authenticated, allow access to public auth route
  return <>{children}</>;
};

export default PublicRoute;
